var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":'/movie/' + _vm.movie.id}},[_c('div',{staticClass:"cardWrapper"},[_c('img',{staticClass:"image",attrs:{"src":_vm.movie.poster}}),_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.movie.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }